import { ProfitAnalysisPage } from "../../_shared/ProfitAnalysisPage";

export default function SoldViewPage() {
  return <ProfitAnalysisPage paType="sold" mode="view" />;
}
